import { useEffect, useState } from 'react';
import * as React from 'react';
import { ResultsMessagingModule } from '@shared-ui/lodging-property-listing';
export const ResultsMessagingModuleSharedUiWrapper = ({
  searchInputs,
  criteriaChanged,
  searchResults
}) => {
  const [inputs, setInputs] = useState(searchInputs);
  useEffect(() => {
    if (criteriaChanged) {
      setInputs(searchInputs);
    }
  }, [criteriaChanged]);
  const resultData = {
    summary: {
      resultMessages: searchResults === null || searchResults === void 0 ? void 0 : searchResults.resultMessages
    }
  };
  return React.createElement(ResultsMessagingModule, {
    inputs: inputs,
    propertySearchListingsPwa: searchResults === null || searchResults === void 0 ? void 0 : searchResults.propertySearchListings,
    data: resultData
  });
};
ResultsMessagingModuleSharedUiWrapper.displayName = 'ResultsMessagingModuleSharedUiWrapper';